import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-ink-50 dark:bg-ink-950 px-6">
      <div className="text-center max-w-md">
        <div className="text-6xl font-bold text-ink-200 dark:text-ink-800">404</div>
        <h1 className="mt-4 text-2xl font-semibold">Page not found</h1>
        <p className="mt-2 text-sm text-ink-500 dark:text-ink-400">
          The page you’re looking for doesn’t exist or you may not have permission to view it.
        </p>
        <div className="mt-6">
          <Link to="/" className="btn-primary">
            Back to home
          </Link>
        </div>
      </div>
    </div>
  );
}
